import { render } from "./PimLabProductsDetail.vue?vue&type=template&id=7d339a7c&scoped=true&ts=true"
import script from "./PimLabProductsDetail.vue?vue&type=script&lang=ts"
export * from "./PimLabProductsDetail.vue?vue&type=script&lang=ts"

import "./PimLabProductsDetail.vue?vue&type=style&index=0&id=7d339a7c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d339a7c"]])

export default __exports__